import clsx from "clsx";
import React, {
  FunctionComponent,
  useCallback,
  useEffect,
  useState,
} from "react";

import { useLockBodyScroll } from "../hooks/useLockBodyScroll/useLockBodyScroll";

type BackdropProps = {
  onHide?: VoidFunction;
  onShow?: VoidFunction;
  visible: boolean;
};

export const Backdrop: FunctionComponent<BackdropProps> = ({
  onHide,
  onShow,
  visible,
}) => {
  const [isNone, setIsNone] = useState(!visible);

  useEffect(() => {
    if (visible) {
      setIsNone(false);
      onShow?.();
    }
  }, [onShow, visible]);

  const handleTransitionEnd = useCallback(() => {
    if (!visible) {
      setIsNone(true);
      onHide?.();
    }
  }, [onHide, visible]);

  useLockBodyScroll(visible);

  return (
    <div
      className={clsx(
        "tw-backdrop",
        visible ? "tw-backdrop--visible" : "tw-backdrop--hidden",
        isNone && "tw-backdrop--none"
      )}
      onAnimationEnd={handleTransitionEnd}
    />
  );
};
